import React, { useRef, useState, useCallback, useMemo } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import PartsCatalogPage from './components/PartsCatologPage';
import PriceListPage from './components/PriceListPage';
import StockInformationPage from './components/StockInfoPage';
import { useLanguage } from '../../contexts/LanguageContext';
import { usePartsCatalog } from './hooks/usePartsCatalog';
import { usePriceList } from './hooks/usePriceList';
import { useStockInformation } from './hooks/useStockInformation';
import GenericTableFilter from '../../components/common/GenericTableFilter';

const DealerPartsCatalog = () => {
    const { th } = useLanguage();
    const toast = useRef(null);
    const [activeTab, setActiveTab] = useState(0);

    // Hook'ları al
    const partsCatalogHook = usePartsCatalog();
    const priceListHook = usePriceList();
    const stockInfoHook = useStockInformation();

    const handleTabChange = useCallback((e) => {
        setActiveTab(e.index);
    }, []);

    // Filtre alanları tanımlaması
    const filterFields = useMemo(() => [
        { 
            field: 'partCode', 
            headerName: th('dealerPartsCatalog.partsCatalog.filters.partCode'), 
            type: 'text' 
        }
    ], [th]);

    // Seçili tab'a göre arama yap (alt tab bilgisini de kullan)
    const handleApplyFilters = useCallback((filters) => {
        const partCode = filters.partCode || '';
        switch (activeTab) {
            case 0: // Parça Katalog
                partsCatalogHook.searchByPartCode(partCode);
                break;
            case 1: // Fiyat Listesi - alt tab'a göre endpoint değişir
                priceListHook.searchByPartCode(partCode, priceListHook.activeTab);
                break;
            case 2: // Stok Bilgisi - alt tab'a göre endpoint değişir
                stockInfoHook.searchByPartCode(partCode, stockInfoHook.activeTab);
                break;
            default:
                break;
        }
    }, [activeTab, partsCatalogHook, priceListHook, stockInfoHook]);

    // Temizle fonksiyonu
    const handleResetFilters = useCallback(() => {
        switch (activeTab) {
            case 0:
                partsCatalogHook.handleReset();
                break;
            case 1:
                priceListHook.handleReset();
                break;
            case 2:
                stockInfoHook.handleReset();
                break;
            default:
                break;
        }
    }, [activeTab, partsCatalogHook, priceListHook, stockInfoHook]);

    return (
        <div className="card">
            <Toast ref={toast} />

            {/* Header */}
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('dealerPartsCatalog.pageTitle')}</h1>
            </div>

            {/* Ortak Filtre Alanı - GenericTableFilter */}
            <GenericTableFilter
                filterFields={filterFields}
                initialFilters={{ partCode: '' }}
                onApplyFilters={handleApplyFilters}
                onResetFilters={handleResetFilters}
                initiallyOpen={true}
            />

            {/* Tab View */}
            <TabView activeIndex={activeTab} onTabChange={handleTabChange} className="dealer-parts-catalog-tabs">
                {/* Parça Katalog Tab */}
                <TabPanel
                    header={th('dealerPartsCatalog.tabs.partsCatalog')}
                    leftIcon="pi pi-list mr-2"
                >
                    <PartsCatalogPage hookData={partsCatalogHook} />
                </TabPanel>

                {/* Fiyat Listesi Tab */}
                <TabPanel
                    header={th('dealerPartsCatalog.tabs.priceList')}
                    leftIcon="pi pi-tag mr-2"
                >
                    <PriceListPage hookData={priceListHook} />
                </TabPanel>

                {/* Stok Bilgisi Tab */}
                <TabPanel
                    header={th('dealerPartsCatalog.tabs.stockInformation')}
                    leftIcon="pi pi-box mr-2"
                >
                    <StockInformationPage hookData={stockInfoHook} />
                </TabPanel>
            </TabView>
        </div>
    );
};

export default DealerPartsCatalog;
